/* AST Practice tracker (sections/ast-practice-tracker.liquid).
   Vanilla JS, no libraries and no network requests. Everything is kept in this browser's localStorage under
   one versioned key, and every read and write is wrapped in try/catch so a private window or a full store
   never breaks the page. Export writes a .json backup and a .csv of sessions; import validates the file and
   asks before it adds to or replaces anything. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ast-pt]');
  if (!root) return;

  var KEY = 'ast-practice-tracker:v1';
  var APP = 'ast-practice-tracker';
  var VERSION = 1;
  var TYPES = { lesson: 'Lesson', freestyle: 'Freestyle', public: 'Public session', office: 'Off-ice' };
  var STATUS = { learning: 'Learning', landed: 'Landed', consistent: 'Consistent' };
  var CATS = { ice: 'Ice time', lessons: 'Lessons', gear: 'Gear', fees: 'Entry and test fees', other: 'Other' };
  var TRACKS = ['Pre-Bronze', 'Bronze', 'Silver', 'Gold', 'other'];
  var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  /* The printable's skill tracker, in its order. Skating skills gets the two crossovers; dance patterns start empty. */
  var GROUPS = [
    { id: 'edges', name: 'Edges and turns', items: ['Forward outside edges', 'Forward inside edges', 'Backward outside edges', 'Backward inside edges', 'Forward three turns', 'Backward three turns', 'Mohawks', 'Brackets', 'Rockers', 'Counters', 'Twizzles'] },
    { id: 'spins', name: 'Spins', items: ['Two-foot spin', 'One-foot spin', 'Scratch spin', 'Sit spin', 'Camel spin', 'Layback spin', 'Combination spin'] },
    { id: 'jumps', name: 'Jumps', items: ['Waltz jump', 'Half flip', 'Salchow', 'Toe loop', 'Loop', 'Flip', 'Lutz', 'Axel'] },
    { id: 'skills', name: 'Skating skills', items: ['Forward crossovers', 'Backward crossovers'] },
    { id: 'dance', name: 'Dance patterns', items: [] }
  ];

  /* ---------- Small helpers ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function has(o, k) { return typeof k === 'string' && Object.prototype.hasOwnProperty.call(o, k); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function keyOf(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parseKey(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function isDate(s) { return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s) && keyOf(parseKey(s)) === s; }
  function today() { return keyOf(new Date()); }
  function monthKey(y, m) { return y + '-' + pad(m + 1); }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function txt(v, max) { return typeof v === 'string' ? v.trim().slice(0, max) : ''; }
  function list(a, max) { return Array.isArray(a) ? a.slice(0, max) : []; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function hours(min) { return String(Math.round(min / 6) / 10); }
  function unique(a) { var seen = {}; return a.filter(function (x) { var k = x.toLowerCase(); if (seen[k]) return false; seen[k] = 1; return true; }); }
  var fmtDay = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  var fmtLong = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  var fmtMonth = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });
  var fmtMonthName = new Intl.DateTimeFormat('en-US', { month: 'long' });
  var fmtFull = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  var money = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function reveal(el, focusEl) {
    if (!el) return;
    if (el.scrollIntoView) el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    var f = focusEl || el;
    if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }
  function status(name, msg) {
    var el = $('[data-pt-status="' + name + '"]');
    if (!el) return;
    el.textContent = '';
    if (msg) setTimeout(function () { el.textContent = msg; }, 30);
  }

  /* ---------- Storage ---------- */
  var storageOK = true;
  var storageProblem = '';
  var unreadable = false;

  function blank() {
    return { app: APP, v: VERSION, sessions: [], goals: {}, elements: { status: {}, custom: [] }, events: [], costs: [], meta: {} };
  }
  function emptyGoals() { return { g: [{ t: '', d: false }, { t: '', d: false }, { t: '', d: false }], clicked: '', fell: '', changing: '' }; }
  function goalsEmpty(g) {
    return !g.clicked && !g.fell && !g.changing && g.g.every(function (x) { return !x.t && !x.d; });
  }

  /* Validates anything that claims to be tracker data (the saved copy or an imported file). Unknown fields are
     dropped, strings are trimmed to length, broken entries are counted and left out. */
  function clean(o) {
    if (!o || typeof o !== 'object' || Array.isArray(o) || o.app !== APP) return null;
    if (typeof o.v !== 'number' || o.v < 1) return null;
    if (o.v > VERSION) return { error: 'newer' };
    var d = blank();
    var dropped = 0;
    var seen = {};
    function freshId(x) {
      var id = (typeof x === 'string' && /^[a-z0-9-]{4,40}$/i.test(x) && !seen[x]) ? x : uid();
      seen[id] = 1;
      return id;
    }
    list(o.sessions, 20000).forEach(function (s) {
      var min = s ? Math.round(Number(s.min)) : NaN;
      if (!s || !isDate(s.date) || !has(TYPES, s.type) || !(min >= 1 && min <= 1440)) { dropped++; return; }
      var felt = Math.round(Number(s.felt));
      d.sessions.push({
        id: freshId(s.id), date: s.date, type: s.type, min: min,
        worked: list(s.worked, 60).map(function (w) { return txt(w, 80); }).filter(Boolean),
        other: txt(s.other, 300), felt: (felt >= 1 && felt <= 5) ? felt : 0, notes: txt(s.notes, 2000)
      });
    });
    if (o.goals && typeof o.goals === 'object' && !Array.isArray(o.goals)) {
      Object.keys(o.goals).slice(0, 1200).forEach(function (k) {
        var g = o.goals[k];
        if (!/^\d{4}-\d{2}$/.test(k) || !g || typeof g !== 'object') return;
        var items = list(g.g, 3).map(function (x) { return { t: txt(x && x.t, 200), d: !!(x && x.d === true) }; });
        while (items.length < 3) items.push({ t: '', d: false });
        var m = { g: items, clicked: txt(g.clicked, 2000), fell: txt(g.fell, 2000), changing: txt(g.changing, 2000) };
        if (!goalsEmpty(m)) d.goals[k] = m;
      });
    }
    var el = (o.elements && typeof o.elements === 'object') ? o.elements : {};
    var idMap = {};
    list(el.custom, 300).forEach(function (c) {
      var name = txt(c && c.name, 80);
      if (!name || !groupById(c.group)) { dropped++; return; }
      var id = (typeof c.id === 'string' && /^c-[a-z0-9]{4,40}$/.test(c.id) && !seen[c.id]) ? c.id : 'c-' + uid();
      seen[id] = 1;
      if (typeof c.id === 'string') idMap[c.id] = id;
      d.elements.custom.push({ id: id, name: name, group: c.group });
    });
    if (el.status && typeof el.status === 'object' && !Array.isArray(el.status)) {
      Object.keys(el.status).slice(0, 1000).forEach(function (k) {
        var key = idMap[k] || k;
        if (has(STATUS, el.status[k]) && /^[a-z0-9:-]{1,120}$/.test(key)) d.elements.status[key] = el.status[k];
      });
    }
    list(o.events, 2000).forEach(function (e) {
      var name = txt(e && e.name, 120);
      if (!e || !isDate(e.date) || !name) { dropped++; return; }
      d.events.push({
        id: freshId(e.id), date: e.date, name: name, track: TRACKS.indexOf(e.track) > -1 ? e.track : '',
        trackOther: txt(e.trackOther, 80), result: txt(e.result, 120), judges: txt(e.judges, 2000), next: txt(e.next, 300)
      });
    });
    list(o.costs, 20000).forEach(function (c) {
      var amt = c ? Number(c.amount) : NaN;
      if (!c || !isDate(c.date) || !has(CATS, c.cat) || !(amt >= 0 && amt <= 1000000)) { dropped++; return; }
      d.costs.push({ id: freshId(c.id), date: c.date, cat: c.cat, amount: Math.round(amt * 100) / 100, note: txt(c.note, 200) });
    });
    if (o.meta && typeof o.meta.backup === 'string' && !isNaN(Date.parse(o.meta.backup))) d.meta.backup = o.meta.backup;
    return { data: d, dropped: dropped };
  }

  function readStore() {
    var raw = null;
    unreadable = false;
    try { raw = window.localStorage.getItem(KEY); } catch (e) { storageOK = false; storageProblem = 'blocked'; return blank(); }
    if (!raw) return blank();
    var r = null;
    try { r = clean(JSON.parse(raw)); } catch (e) { r = null; }
    if (r && r.data) return r.data;
    /* Never overwrite a copy we can't read: park it under its own key first. */
    try { window.localStorage.setItem(KEY + ':unreadable', raw); } catch (e) {}
    unreadable = true;
    return blank();
  }
  function writeStore() {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(state));
      storageOK = true;
      storageProblem = '';
    } catch (e) {
      storageOK = false;
      storageProblem = (e && (e.name === 'QuotaExceededError' || e.code === 22)) ? 'full' : 'blocked';
    }
    showStorage();
    return storageOK;
  }
  function probeStore() {
    try {
      window.localStorage.setItem(KEY + ':probe', '1');
      window.localStorage.removeItem(KEY + ':probe');
    } catch (e) { storageOK = false; storageProblem = storageProblem || 'blocked'; }
  }
  function showStorage() {
    var el = $('[data-pt-storage]');
    var msg = '';
    if (!storageOK && storageProblem === 'full') {
      msg = 'This browser has run out of room for the tracker, so your last change wasn\u2019t saved. Save a backup now, then delete a few old entries or costs to make space.';
    } else if (!storageOK) {
      msg = 'This browser isn\u2019t letting the tracker save anything, which usually means a private window or blocked site data. You can still fill it in, but it will be gone when you close the page unless you save a backup first.';
    } else if (unreadable) {
      msg = 'Your saved log couldn\u2019t be read, so the tracker has started fresh. The old copy is still kept in this browser, and if you have a backup you can restore it at the bottom of the tracker.';
    }
    el.textContent = msg;
    el.hidden = !msg;
  }

  /* ---------- Elements ---------- */
  function groupById(id) {
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].id === id) return GROUPS[i];
    return null;
  }
  function elementList() {
    var out = [];
    GROUPS.forEach(function (g) {
      g.items.forEach(function (n) { out.push({ id: g.id + ':' + slug(n), name: n, group: g.id, custom: false }); });
      state.elements.custom.forEach(function (c) { if (c.group === g.id) out.push({ id: c.id, name: c.name, group: g.id, custom: true }); });
    });
    return out;
  }

  /* ---------- State ---------- */
  var state = readStore();
  var now = new Date();
  var view = { y: now.getFullYear(), m: now.getMonth() };   /* month shown on the Sessions tab */
  var gview = { y: now.getFullYear(), m: now.getMonth() };  /* month shown on the Goals tab */
  var editing = { session: null, event: null, cost: null };
  var openGroups = {};
  var pendingImport = null;
  var goalTimer = null;

  var sessionForm = $('[data-pt-form="session"]');
  var goalsForm = $('[data-pt-form="goals"]');
  var elForm = $('[data-pt-form="element"]');
  var eventForm = $('[data-pt-form="event"]');
  var costForm = $('[data-pt-form="cost"]');
  var tabs = $$('[data-pt-tab]');

  function field(form, name) { return form.elements.namedItem(name); }

  /* ---------- Tabs ---------- */
  function selectTab(name, focusTab, keepHash) {
    if (!$('[data-pt-panel="' + name + '"]')) name = 'log';
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-pt-tab') === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focusTab) t.focus();
    });
    $$('[data-pt-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-pt-panel') !== name; });
    if (!keepHash && window.history && history.replaceState) {
      try { history.replaceState(null, '', '#' + name); } catch (e) {}
    }
  }
  $('[role="tablist"]').addEventListener('keydown', function (e) {
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    var n = null;
    if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    if (n === null) return;
    e.preventDefault();
    selectTab(tabs[n].getAttribute('data-pt-tab'), true);
  });

  /* ---------- Totals ---------- */
  function weekStart(d) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    x.setDate(x.getDate() - (x.getDay() + 6) % 7);
    return x;
  }
  /* Weeks run Monday to Sunday. The streak counts back from this week, or from last week if nothing is logged
     yet this week, so it doesn't drop to zero on a Monday morning. */
  function streak() {
    var t = today();
    var weeks = {};
    state.sessions.forEach(function (s) { if (s.date <= t) weeks[keyOf(weekStart(parseKey(s.date)))] = 1; });
    var w = weekStart(new Date());
    if (!weeks[keyOf(w)]) w.setDate(w.getDate() - 7);
    var n = 0;
    while (weeks[keyOf(w)]) { n++; w.setDate(w.getDate() - 7); }
    return n;
  }
  function renderTotals() {
    var d = new Date();
    var mk = monthKey(d.getFullYear(), d.getMonth());
    var name = fmtMonthName.format(d);
    var ms = state.sessions.filter(function (s) { return s.date.slice(0, 7) === mk; });
    var min = ms.reduce(function (a, s) { return a + s.min; }, 0);
    $('[data-pt-total="sessions"]').textContent = ms.length;
    $('[data-pt-total="hours"]').textContent = hours(min);
    var weeks = streak();
    $('[data-pt-total="streak"]').textContent = weeks;
    $('[data-pt-streak-label]').textContent = weeks === 1 ? 'Week in a row' : 'Weeks in a row';
    $('[data-pt-totals-title]').textContent = name + ' so far';
  }

  /* ---------- Log form ---------- */
  function checkbox(el, checked) {
    return '<label class="ast-pt__check"><input type="checkbox" name="worked" value="' + esc(el.name) + '"' + (checked ? ' checked' : '') + '><span>' + esc(el.name) + '</span></label>';
  }
  function currentWorked() {
    return $$('input[name="worked"]:checked', sessionForm).map(function (i) { return i.value; });
  }
  function renderWorked(selected) {
    var sel = (selected || []).map(function (s) { return s.toLowerCase(); });
    var els = elementList();
    var mine = els.filter(function (e) { return state.elements.status[e.id]; });
    var mineIds = {};
    mine.forEach(function (e) { mineIds[e.id] = 1; });
    $('[data-pt-worked-mine]').innerHTML = mine.length
      ? '<p class="ast-pt__lbl ast-pt__lbl--sub">Your elements</p><div class="ast-pt__checks">' + mine.map(function (e) { return checkbox(e, sel.indexOf(e.name.toLowerCase()) > -1); }).join('') + '</div>'
      : '';
    var all = '';
    GROUPS.forEach(function (g) {
      var items = els.filter(function (e) { return e.group === g.id && !mineIds[e.id]; });
      if (!items.length) return;
      all += '<p class="ast-pt__lbl ast-pt__lbl--sub">' + esc(g.name) + '</p><div class="ast-pt__checks">' + items.map(function (e) { return checkbox(e, sel.indexOf(e.name.toLowerCase()) > -1); }).join('') + '</div>';
    });
    $('[data-pt-worked-all]').innerHTML = all;
    updateWorkedSummary(mine.length > 0);
  }
  function updateWorkedSummary(hasMine) {
    if (typeof hasMine !== 'boolean') hasMine = !!$('[data-pt-worked-mine]').firstChild;
    var n = $$('[data-pt-worked-all] input:checked').length;
    $('[data-pt-worked-summary]').textContent = (hasMine ? 'More elements and moves' : 'Pick from the full list of elements and moves') + (n ? ' (' + n + ' picked)' : '');
  }
  function clearErrors(form) {
    var box = $('[data-pt-errors]', form);
    if (box) { box.hidden = true; box.innerHTML = ''; }
    $$('[aria-invalid]', form).forEach(function (i) { i.removeAttribute('aria-invalid'); });
  }
  function showErrors(form, errs) {
    var box = $('[data-pt-errors]', form);
    box.setAttribute('role', 'alert');
    box.innerHTML = '<p class="ast-pt__lbl">Before you save</p><ul>' + errs.map(function (e) { return '<li>' + esc(e[1]) + '</li>'; }).join('') + '</ul>';
    box.hidden = false;
    errs.forEach(function (e) { e[0].setAttribute('aria-invalid', 'true'); });
    errs[0][0].focus();
  }
  function resetSessionForm() {
    sessionForm.reset();
    field(sessionForm, 'date').value = today();
    editing.session = null;
    $('[data-pt-log-title]').textContent = 'Log a session';
    $('[data-pt-save-label]', sessionForm).textContent = 'Save session';
    $('[data-pt-cancel="session"]').hidden = true;
    clearErrors(sessionForm);
    renderWorked([]);
    $('[data-pt-worked-more]').open = false;
  }
  sessionForm.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors(sessionForm);
    var date = field(sessionForm, 'date').value;
    var type = field(sessionForm, 'type').value;
    var min = Math.round(Number(field(sessionForm, 'min').value));
    var errs = [];
    if (!isDate(date)) errs.push([field(sessionForm, 'date'), 'Add the date of the session.']);
    if (!has(TYPES, type)) errs.push([$('input[name="type"]', sessionForm), 'Choose lesson, freestyle, public session or off-ice.']);
    if (!(min >= 1 && min <= 1440)) errs.push([field(sessionForm, 'min'), 'Add how many minutes it was, between 1 and 1440.']);
    if (errs.length) { showErrors(sessionForm, errs); return; }
    var rec = {
      id: editing.session || uid(), date: date, type: type, min: min, worked: unique(currentWorked()),
      other: txt(field(sessionForm, 'other').value, 300), felt: Number(field(sessionForm, 'felt').value) || 0,
      notes: txt(field(sessionForm, 'notes').value, 2000)
    };
    var wasEditing = !!editing.session;
    if (wasEditing) {
      state.sessions = state.sessions.map(function (s) { return s.id === rec.id ? rec : s; });
    } else {
      state.sessions.push(rec);
    }
    var ok = writeStore();
    var d = parseKey(date);
    view = { y: d.getFullYear(), m: d.getMonth() };
    resetSessionForm();
    renderAll();
    var n = state.sessions.filter(function (s) { return s.date.slice(0, 7) === date.slice(0, 7); }).length;
    var msg = ok
      ? (wasEditing ? 'Your changes are saved.' : 'Your session is saved. That makes ' + plural(n, 'session', 'sessions') + ' in ' + fmtMonthName.format(d) + '.')
      : 'The session is on the page, but the browser wouldn\u2019t save it. Save a backup before you close the page.';
    if (wasEditing) {
      selectTab('sessions');
      status('sessions', msg);
      reveal($('#ast-pt-s-' + rec.id));
    } else {
      status('log', msg);
    }
  });
  sessionForm.addEventListener('change', function (e) {
    if (e.target.name === 'worked') updateWorkedSummary();
    if (e.target.type === 'radio') $$('input[name="' + e.target.name + '"]', sessionForm).forEach(function (r) { r.removeAttribute('aria-invalid'); });
    else e.target.removeAttribute('aria-invalid');
  });

  /* ---------- Sessions: month view and list ---------- */
  function confirmHTML(kind, id, question) {
    return '<div class="ast-pt__confirm" data-pt-confirm="' + esc(id) + '" hidden><p>' + esc(question) + ' You can\u2019t undo this.</p>' +
      '<div class="ast-pt__actions ast-pt__actions--wrap"><button type="button" class="btn btn--secondary ast-pt__danger" data-pt-del-yes="' + kind + '" data-id="' + esc(id) + '">Yes, delete it</button>' +
      '<button type="button" class="btn btn--secondary" data-pt-del-no data-id="' + esc(id) + '">Keep it</button></div></div>';
  }
  function actionsHTML(kind, id, what) {
    return '<div class="ast-pt__entry-actions">' +
      '<button type="button" class="ast-pt__btn" data-pt-edit="' + kind + '" data-id="' + esc(id) + '">Edit<span class="ast-pt-vh"> ' + esc(what) + '</span></button>' +
      '<button type="button" class="ast-pt__btn" data-pt-del="' + kind + '" data-id="' + esc(id) + '">Delete<span class="ast-pt-vh"> ' + esc(what) + '</span></button></div>' +
      confirmHTML(kind, id, 'Delete ' + what + '?');
  }
  function line(label, value) {
    return '<p class="ast-pt__entry-line"><span class="ast-pt__lbl">' + esc(label) + '</span> ' + esc(value) + '</p>';
  }
  function sessionHTML(s) {
    var d = parseKey(s.date);
    var day = fmtDay.format(d);
    var worked = s.worked.concat(s.other ? [s.other] : []).join(', ');
    return '<article class="ast-pt__entry" id="ast-pt-s-' + esc(s.id) + '" data-pt-date="' + esc(s.date) + '" tabindex="-1">' +
      '<div class="ast-pt__entry-head"><h3 class="ast-pt__entry-title">' + esc(day) + '</h3>' +
      '<p class="ast-pt__entry-meta">' + esc(TYPES[s.type]) + ' <span aria-hidden="true">&middot;</span> ' + s.min + ' min' +
      (s.felt ? ' <span aria-hidden="true">&middot;</span> Felt ' + s.felt + '<span class="ast-pt-vh"> out of 5</span>' : '') + '</p></div>' +
      (worked ? line('Worked on', worked) : '') +
      (s.notes ? '<p class="ast-pt__entry-notes">' + esc(s.notes) + '</p>' : '') +
      actionsHTML('session', s.id, 'the session from ' + day) + '</article>';
  }
  function bySessionDesc(a, b) { return a.date < b.date ? 1 : a.date > b.date ? -1 : 0; }
  function renderSessions() {
    var first = new Date(view.y, view.m, 1);
    var mk = monthKey(view.y, view.m);
    var label = fmtMonth.format(first);
    $('[data-pt-month-title]').textContent = label;
    var ms = state.sessions.filter(function (s) { return s.date.slice(0, 7) === mk; }).sort(bySessionDesc);
    var byDay = {};
    ms.forEach(function (s) { (byDay[s.date] = byDay[s.date] || []).push(s); });
    var count = new Date(view.y, view.m + 1, 0).getDate();
    var lead = (first.getDay() + 6) % 7;
    var t = today();
    var html = '<table class="ast-pt__cal"><caption class="ast-pt-vh">Days with sessions in ' + esc(label) + '</caption><thead><tr>' +
      DAYS.map(function (d) { return '<th scope="col"><span aria-hidden="true">' + d.charAt(0) + '</span><span class="ast-pt-vh">' + d + '</span></th>'; }).join('') +
      '</tr></thead><tbody><tr>';
    var cell = 0;
    for (var i = 0; i < lead; i++, cell++) html += '<td></td>';
    for (var day = 1; day <= count; day++, cell++) {
      if (cell && cell % 7 === 0) html += '</tr><tr>';
      var k = monthKey(view.y, view.m) + '-' + pad(day);
      var cur = k === t ? ' aria-current="date"' : '';
      var cls = 'ast-pt__day' + (k === t ? ' is-today' : '');
      if (byDay[k]) {
        var mins = byDay[k].reduce(function (a, s) { return a + s.min; }, 0);
        html += '<td><button type="button" class="' + cls + ' is-on" data-pt-day="' + k + '"' + cur + ' aria-label="' +
          esc(fmtLong.format(parseKey(k)) + ', ' + plural(byDay[k].length, 'session', 'sessions') + ', ' + mins + ' minutes') + '">' + day + '</button></td>';
      } else {
        html += '<td><span class="' + cls + '"' + cur + '>' + day + '</span></td>';
      }
    }
    while (cell % 7) { html += '<td></td>'; cell++; }
    html += '</tr></tbody></table>';
    $('[data-pt-calendar]').innerHTML = html;

    var min = ms.reduce(function (a, s) { return a + s.min; }, 0);
    $('[data-pt-month-sum]').textContent = ms.length
      ? plural(ms.length, 'session', 'sessions') + ' on ' + plural(Object.keys(byDay).length, 'day', 'days') + ', ' + hours(min) + ' hours in all'
      : '';

    var box = $('[data-pt-sessions]');
    if (!state.sessions.length) {
      box.innerHTML = '<div class="ast-pt__example"><p class="ast-pt__lbl">Nothing logged yet</p>' +
        '<p>Your sessions will show up here with the newest first, and the days you skated get marked on the calendar above. A typical entry might be a 45 minute freestyle where you worked on your waltz jump and back crossovers and gave it a 4.</p>' +
        '<p><button type="button" class="btn btn--primary" data-pt-goto="log">Log a session</button></p></div>';
    } else if (!ms.length) {
      box.innerHTML = '<p class="ast-pt__empty">Nothing logged in ' + esc(fmtMonthName.format(first)) + ' yet.</p>';
    } else {
      box.innerHTML = ms.map(sessionHTML).join('');
    }
  }

  /* ---------- Goals ---------- */
  function renderGoals() {
    var mk = monthKey(gview.y, gview.m);
    var g = state.goals[mk] || emptyGoals();
    $('[data-pt-goals-title]').textContent = fmtMonth.format(new Date(gview.y, gview.m, 1));
    $$('[data-pt-goal]').forEach(function (i) { i.value = g.g[+i.getAttribute('data-pt-goal')].t; });
    $$('[data-pt-goal-done]').forEach(function (i) { i.checked = g.g[+i.getAttribute('data-pt-goal-done')].d; });
    $$('[data-pt-goal-text]').forEach(function (i) { i.value = g[i.getAttribute('data-pt-goal-text')] || ''; });
  }
  function onGoal(e) {
    var t = e.target;
    var mk = monthKey(gview.y, gview.m);
    var g = state.goals[mk] || emptyGoals();
    if (t.hasAttribute('data-pt-goal')) g.g[+t.getAttribute('data-pt-goal')].t = t.value.slice(0, 200);
    else if (t.hasAttribute('data-pt-goal-done')) g.g[+t.getAttribute('data-pt-goal-done')].d = t.checked;
    else if (t.hasAttribute('data-pt-goal-text')) g[t.getAttribute('data-pt-goal-text')] = t.value.slice(0, 2000);
    else return;
    if (goalsEmpty(g)) delete state.goals[mk];
    else state.goals[mk] = g;
    clearTimeout(goalTimer);
    goalTimer = setTimeout(function () { if (writeStore()) status('goals', 'Your goals are saved on this device.'); }, 400);
  }
  goalsForm.addEventListener('input', onGoal);
  goalsForm.addEventListener('change', onGoal);
  goalsForm.addEventListener('submit', function (e) { e.preventDefault(); });

  /* ---------- Elements ---------- */
  function elementRow(e) {
    var st = state.elements.status[e.id] || '';
    var sid = 'ast-pt-el-' + e.id.replace(/[^a-z0-9-]/gi, '-');
    return '<div class="ast-pt__el"><label class="ast-pt__el-name" for="' + sid + '">' + esc(e.name) + '</label>' +
      '<select class="ast-pt__input ast-pt__select ast-pt__el-select' + (st ? ' is-set' : '') + '" id="' + sid + '" data-pt-el="' + esc(e.id) + '">' +
      '<option value="">Not yet</option>' +
      Object.keys(STATUS).map(function (k) { return '<option value="' + k + '"' + (st === k ? ' selected' : '') + '>' + STATUS[k] + '</option>'; }).join('') +
      '</select>' +
      (e.custom ? '<button type="button" class="ast-pt__btn ast-pt__el-remove" data-pt-del="element" data-id="' + esc(e.id) + '">Remove<span class="ast-pt-vh"> ' + esc(e.name) + '</span></button>' +
        confirmHTML('element', e.id, 'Remove ' + e.name + ' from your list?') : '') +
      '</div>';
  }
  function groupMeta(items) {
    var n = items.filter(function (e) { return state.elements.status[e.id]; }).length;
    return items.length ? n + ' of ' + items.length + ' marked' : 'None yet';
  }
  function renderElCounts() {
    var c = { learning: 0, landed: 0, consistent: 0 };
    elementList().forEach(function (e) { var st = state.elements.status[e.id]; if (st) c[st]++; });
    $('[data-pt-el-counts]').textContent = (c.learning + c.landed + c.consistent)
      ? c.learning + ' learning, ' + c.landed + ' landed, ' + c.consistent + ' consistent'
      : 'You haven\u2019t marked any elements yet. Open a group and set the ones you\u2019re working on.';
  }
  function renderElements() {
    var els = elementList();
    var anySet = els.some(function (e) { return state.elements.status[e.id]; });
    var html = '';
    GROUPS.forEach(function (g) {
      var items = els.filter(function (e) { return e.group === g.id; });
      if (!has(openGroups, g.id)) openGroups[g.id] = anySet ? items.some(function (e) { return state.elements.status[e.id]; }) : g.id === 'jumps';
      html += '<details class="ast-pt__group" data-pt-group="' + g.id + '"' + (openGroups[g.id] ? ' open' : '') + '>' +
        '<summary><span class="ast-pt__group-name">' + esc(g.name) + '</span><span class="ast-pt__meta" data-pt-group-meta>' + esc(groupMeta(items)) + '</span></summary>' +
        '<div class="ast-pt__group-body">' + (items.length ? items.map(elementRow).join('') : '<p class="ast-pt__empty">There\u2019s nothing in this group yet. You can add one with the form under Add your own.</p>') + '</div></details>';
    });
    $('[data-pt-elements]').innerHTML = html;
    renderElCounts();
  }
  root.addEventListener('toggle', function (e) {
    var g = e.target && e.target.getAttribute && e.target.getAttribute('data-pt-group');
    if (g) openGroups[g] = e.target.open;
  }, true);
  root.addEventListener('change', function (e) {
    var id = e.target.getAttribute('data-pt-el');
    if (!id) return;
    if (e.target.value && has(STATUS, e.target.value)) state.elements.status[id] = e.target.value;
    else delete state.elements.status[id];
    e.target.classList.toggle('is-set', !!e.target.value);
    var ok = writeStore();
    var group = e.target.closest('[data-pt-group]');
    var gid = group.getAttribute('data-pt-group');
    $('[data-pt-group-meta]', group).textContent = groupMeta(elementList().filter(function (x) { return x.group === gid; }));
    renderElCounts();
    renderWorked(currentWorked());
    if (ok) status('elements', 'Your elements are saved on this device.');
  });
  var groupSelect = $('[data-pt-el-groups]');
  groupSelect.innerHTML = GROUPS.map(function (g) { return '<option value="' + g.id + '"' + (g.id === 'jumps' ? ' selected' : '') + '>' + esc(g.name) + '</option>'; }).join('');
  elForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = $('#ast-pt-el-name');
    var name = txt(input.value, 80);
    var g = groupById(groupSelect.value);
    if (!name || !g) { input.setAttribute('aria-invalid', 'true'); input.focus(); status('elements', 'Type the name of the element first.'); return; }
    var exists = elementList().some(function (x) { return x.name.toLowerCase() === name.toLowerCase(); });
    if (exists) { input.focus(); status('elements', name + ' is already on your list.'); return; }
    state.elements.custom.push({ id: 'c-' + uid(), name: name, group: g.id });
    input.value = '';
    input.removeAttribute('aria-invalid');
    openGroups[g.id] = true;
    var ok = writeStore();
    renderElements();
    renderWorked(currentWorked());
    status('elements', ok ? name + ' is now in ' + g.name + '. Set its status in the list above.' : '');
  });

  /* ---------- Tests and competitions ---------- */
  function trackOtherToggle() {
    $('[data-pt-track-other]').hidden = field(eventForm, 'track').value !== 'other';
  }
  field(eventForm, 'track').addEventListener('change', trackOtherToggle);
  function eventHTML(e) {
    var d = parseKey(e.date);
    var track = e.track === 'other' ? e.trackOther : e.track;
    var days = Math.round((d - parseKey(today())) / 864e5);
    var when = days === 0 ? 'Today' : days > 0 ? 'In ' + plural(days, 'day', 'days') : '';
    var meta = [fmtFull.format(d)];
    if (when) meta.push(when);
    if (track) meta.push(track);
    return '<article class="ast-pt__entry" id="ast-pt-e-' + esc(e.id) + '" tabindex="-1">' +
      '<div class="ast-pt__entry-head"><h4 class="ast-pt__entry-title">' + esc(e.name) + '</h4>' +
      '<p class="ast-pt__entry-meta">' + meta.map(esc).join(' <span aria-hidden="true">&middot;</span> ') + '</p></div>' +
      (e.result ? line('Result', e.result) : '') +
      (e.judges ? '<p class="ast-pt__entry-line ast-pt__entry-notes"><span class="ast-pt__lbl">Judges\u2019 notes</span> ' + esc(e.judges) + '</p>' : '') +
      (e.next ? line('One thing to work on', e.next) : '') +
      actionsHTML('event', e.id, e.name) + '</article>';
  }
  function renderEvents() {
    var t = today();
    var up = state.events.filter(function (e) { return e.date >= t; }).sort(function (a, b) { return a.date < b.date ? -1 : a.date > b.date ? 1 : 0; });
    var past = state.events.filter(function (e) { return e.date < t; }).sort(bySessionDesc);
    var html = '';
    if (!state.events.length) html = '<p class="ast-pt__empty">You haven\u2019t added any tests or competitions yet. They\u2019ll show up here once you\u2019ve added one.</p>';
    if (up.length) html += '<h3 class="ast-pt__h3">Coming up</h3>' + up.map(eventHTML).join('');
    if (past.length) html += '<h3 class="ast-pt__h3">Done</h3>' + past.map(eventHTML).join('');
    $('[data-pt-events]').innerHTML = html;
  }
  function resetEventForm() {
    eventForm.reset();
    editing.event = null;
    $('[data-pt-event-title]').textContent = 'Add a test or competition';
    $('[data-pt-save-label]', eventForm).textContent = 'Save';
    $('[data-pt-cancel="event"]').hidden = true;
    clearErrors(eventForm);
    trackOtherToggle();
  }
  eventForm.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors(eventForm);
    var date = field(eventForm, 'date').value;
    var name = txt(field(eventForm, 'name').value, 120);
    var errs = [];
    if (!isDate(date)) errs.push([field(eventForm, 'date'), 'Add the date.']);
    if (!name) errs.push([field(eventForm, 'name'), 'Add the name of the event, test or comp.']);
    if (errs.length) { showErrors(eventForm, errs); return; }
    var track = field(eventForm, 'track').value;
    var rec = {
      id: editing.event || uid(), date: date, name: name, track: TRACKS.indexOf(track) > -1 ? track : '',
      trackOther: track === 'other' ? txt(field(eventForm, 'trackOther').value, 80) : '',
      result: txt(field(eventForm, 'result').value, 120), judges: txt(field(eventForm, 'judges').value, 2000),
      next: txt(field(eventForm, 'next').value, 300)
    };
    var wasEditing = !!editing.event;
    if (wasEditing) state.events = state.events.map(function (x) { return x.id === rec.id ? rec : x; });
    else state.events.push(rec);
    var ok = writeStore();
    resetEventForm();
    renderEvents();
    status('tests', ok ? (wasEditing ? 'Your changes are saved.' : name + ' is saved.') : 'The browser wouldn\u2019t save that. Save a backup before you close the page.');
    reveal($('#ast-pt-e-' + rec.id));
  });

  /* ---------- Costs ---------- */
  function costHTML(c) {
    var day = fmtFull.format(parseKey(c.date));
    return '<article class="ast-pt__entry ast-pt__entry--cost" id="ast-pt-c-' + esc(c.id) + '" tabindex="-1">' +
      '<div class="ast-pt__entry-head"><p class="ast-pt__entry-title">' + esc(CATS[c.cat]) + '</p><p class="ast-pt__entry-amt">' + money.format(c.amount) + '</p></div>' +
      '<p class="ast-pt__entry-meta">' + esc(day) + (c.note ? ' <span aria-hidden="true">&middot;</span> ' + esc(c.note) : '') + '</p>' +
      actionsHTML('cost', c.id, CATS[c.cat].toLowerCase() + ' cost from ' + day) + '</article>';
  }
  function renderCosts() {
    var d = new Date();
    var mk = monthKey(d.getFullYear(), d.getMonth());
    var yk = String(d.getFullYear());
    var totals = '';
    if (state.costs.length) {
      var rows = '';
      var tm = 0;
      var ty = 0;
      Object.keys(CATS).forEach(function (k) {
        var m = 0;
        var y = 0;
        state.costs.forEach(function (c) {
          if (c.cat !== k) return;
          if (c.date.slice(0, 7) === mk) m += c.amount;
          if (c.date.slice(0, 4) === yk) y += c.amount;
        });
        tm += m;
        ty += y;
        if (m || y) rows += '<tr><th scope="row">' + esc(CATS[k]) + '</th><td class="n">' + money.format(m) + '</td><td class="n">' + money.format(y) + '</td></tr>';
      });
      totals = '<table class="ast-pt__table"><caption class="ast-pt-vh">Costs by category</caption><thead><tr><th scope="col">Category</th><th scope="col" class="n">' + esc(fmtMonthName.format(d)) + '</th><th scope="col" class="n">' + yk + '</th></tr></thead><tbody>' +
        rows + '<tr class="is-total"><th scope="row">Total</th><td class="n">' + money.format(tm) + '</td><td class="n">' + money.format(ty) + '</td></tr></tbody></table>';
    }
    $('[data-pt-cost-totals]').innerHTML = totals;
    var sorted = state.costs.slice().sort(bySessionDesc);
    var shown = sorted.slice(0, 30);
    $('[data-pt-costs-list]').innerHTML = shown.map(costHTML).join('') +
      (sorted.length > shown.length ? '<p class="ast-pt__meta">Showing the 30 most recent costs. Older ones are still counted in the totals and kept in your backup.</p>' : '');
  }
  function resetCostForm() {
    costForm.reset();
    field(costForm, 'date').value = today();
    editing.cost = null;
    $('[data-pt-cost-title]').textContent = 'Add a cost';
    $('[data-pt-save-label]', costForm).textContent = 'Add cost';
    $('[data-pt-cancel="cost"]').hidden = true;
    clearErrors(costForm);
  }
  costForm.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors(costForm);
    var date = field(costForm, 'date').value;
    var raw = field(costForm, 'amount').value;
    var amt = Number(raw);
    var errs = [];
    if (!isDate(date)) errs.push([field(costForm, 'date'), 'Add the date.']);
    if (raw === '' || !(amt >= 0 && amt <= 1000000)) errs.push([field(costForm, 'amount'), 'Add the amount as a number, like 18 or 18.50.']);
    if (errs.length) { showErrors(costForm, errs); return; }
    var cat = field(costForm, 'cat').value;
    var rec = { id: editing.cost || uid(), date: date, cat: has(CATS, cat) ? cat : 'other', amount: Math.round(amt * 100) / 100, note: txt(field(costForm, 'note').value, 200) };
    var wasEditing = !!editing.cost;
    if (wasEditing) state.costs = state.costs.map(function (x) { return x.id === rec.id ? rec : x; });
    else state.costs.push(rec);
    var ok = writeStore();
    resetCostForm();
    renderCosts();
    status('costs', ok ? (wasEditing ? 'Your changes are saved.' : 'The cost is saved.') : 'The browser wouldn\u2019t save that. Save a backup before you close the page.');
  });

  /* ---------- Edit and delete ---------- */
  function startEdit(kind, id) {
    if (kind === 'session') {
      var s = state.sessions.filter(function (x) { return x.id === id; })[0];
      if (!s) return;
      selectTab('log');
      resetSessionForm();
      editing.session = id;
      field(sessionForm, 'date').value = s.date;
      $$('input[name="type"]', sessionForm).forEach(function (r) { r.checked = r.value === s.type; });
      field(sessionForm, 'min').value = s.min;
      $$('input[name="felt"]', sessionForm).forEach(function (r) { r.checked = +r.value === s.felt; });
      field(sessionForm, 'notes').value = s.notes;
      renderWorked(s.worked);
      var ticked = currentWorked().map(function (w) { return w.toLowerCase(); });
      var loose = s.worked.filter(function (w) { return ticked.indexOf(w.toLowerCase()) < 0; });
      field(sessionForm, 'other').value = loose.concat(s.other ? [s.other] : []).join(', ');
      if ($$('[data-pt-worked-all] input:checked').length) $('[data-pt-worked-more]').open = true;
      $('[data-pt-log-title]').textContent = 'Edit session';
      $('[data-pt-save-label]', sessionForm).textContent = 'Save changes';
      $('[data-pt-cancel="session"]').hidden = false;
      reveal($('[data-pt-log-title]'));
    } else if (kind === 'event') {
      var ev = state.events.filter(function (x) { return x.id === id; })[0];
      if (!ev) return;
      resetEventForm();
      editing.event = id;
      ['date', 'name', 'track', 'trackOther', 'result', 'judges', 'next'].forEach(function (k) { field(eventForm, k).value = ev[k] || ''; });
      trackOtherToggle();
      $('[data-pt-event-title]').textContent = 'Edit ' + ev.name;
      $('[data-pt-save-label]', eventForm).textContent = 'Save changes';
      $('[data-pt-cancel="event"]').hidden = false;
      reveal($('[data-pt-event-title]'));
    } else if (kind === 'cost') {
      var c = state.costs.filter(function (x) { return x.id === id; })[0];
      if (!c) return;
      resetCostForm();
      editing.cost = id;
      field(costForm, 'date').value = c.date;
      field(costForm, 'cat').value = c.cat;
      field(costForm, 'amount').value = c.amount;
      field(costForm, 'note').value = c.note;
      $('[data-pt-cost-title]').textContent = 'Edit cost';
      $('[data-pt-save-label]', costForm).textContent = 'Save changes';
      $('[data-pt-cancel="cost"]').hidden = false;
      reveal($('[data-pt-cost-title]'));
    }
  }
  function cancelEdit(kind) {
    if (kind === 'session') {
      var id = editing.session;
      resetSessionForm();
      selectTab('sessions');
      reveal(id && $('#ast-pt-s-' + id));
    } else if (kind === 'event') {
      var eid = editing.event;
      resetEventForm();
      reveal(eid && $('#ast-pt-e-' + eid));
    } else if (kind === 'cost') {
      var cid = editing.cost;
      resetCostForm();
      reveal(cid && $('#ast-pt-c-' + cid));
    }
  }
  function confirmBox(id) {
    return $$('[data-pt-confirm]').filter(function (c) { return c.getAttribute('data-pt-confirm') === id; })[0];
  }
  function askDelete(id) {
    $$('[data-pt-confirm]').forEach(function (c) { c.hidden = true; });
    var box = confirmBox(id);
    if (!box) return;
    box.hidden = false;
    $('[data-pt-del-no]', box).focus();
  }
  function cancelDelete(id) {
    var box = confirmBox(id);
    if (!box) return;
    box.hidden = true;
    var btn = $$('[data-pt-del]').filter(function (b) { return b.getAttribute('data-id') === id; })[0];
    if (btn) btn.focus();
  }
  function doDelete(kind, id) {
    var ok;
    if (kind === 'session') {
      state.sessions = state.sessions.filter(function (s) { return s.id !== id; });
      if (editing.session === id) resetSessionForm();
      ok = writeStore();
      renderTotals();
      renderSessions();
      $('[data-pt-log-example]').hidden = state.sessions.length > 0;
      status('sessions', ok ? 'The session is deleted.' : '');
      $('[data-pt-sessions]').focus();
    } else if (kind === 'event') {
      state.events = state.events.filter(function (s) { return s.id !== id; });
      if (editing.event === id) resetEventForm();
      ok = writeStore();
      renderEvents();
      status('tests', ok ? 'That test or competition is deleted.' : '');
      $('[data-pt-events]').focus();
    } else if (kind === 'cost') {
      state.costs = state.costs.filter(function (s) { return s.id !== id; });
      if (editing.cost === id) resetCostForm();
      ok = writeStore();
      renderCosts();
      status('costs', ok ? 'The cost is deleted.' : '');
      $('[data-pt-costs-list]').focus();
    } else if (kind === 'element') {
      var gone = state.elements.custom.filter(function (c) { return c.id === id; })[0];
      state.elements.custom = state.elements.custom.filter(function (c) { return c.id !== id; });
      delete state.elements.status[id];
      ok = writeStore();
      renderElements();
      renderWorked(currentWorked());
      status('elements', ok && gone ? gone.name + ' is off your list. Sessions that mention it keep the name.' : '');
      $('#ast-pt-el-name').focus();
    }
  }

  /* ---------- Backups ---------- */
  function download(name, text, type) {
    var blob = new Blob([text], { type: type });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(url); a.remove(); }, 1500);
  }
  function hasData(d) {
    return !!(d.sessions.length || d.events.length || d.costs.length || d.elements.custom.length ||
      Object.keys(d.goals).length || Object.keys(d.elements.status).length);
  }
  function renderBackupMeta() {
    var el = $('[data-pt-last-backup]');
    var last = state.meta.backup ? new Date(state.meta.backup) : null;
    var msg = last ? 'Your last backup from this device was saved on ' + fmtFull.format(last) + '.' : 'You haven\u2019t saved a backup from this device yet.';
    var stale = !last || (Date.now() - last.getTime()) > 30 * 864e5;
    if (stale && state.sessions.length >= 5) msg += ' Now would be a good time to save one.';
    el.textContent = hasData(state) ? msg : '';
  }
  function exportJSON() {
    var data = JSON.parse(JSON.stringify(state));
    data.exported = new Date().toISOString();
    download('ast-practice-tracker-backup-' + today() + '.json', JSON.stringify(data, null, 2), 'application/json');
    state.meta.backup = data.exported;
    writeStore();
    renderBackupMeta();
    status('backup', 'Your backup is in your downloads. Keep a copy somewhere other than this phone, like your email or cloud storage.');
  }
  function csvCell(v) {
    var s = String(v == null ? '' : v);
    if (/^[=+\-@\t\r]/.test(s)) s = '\'' + s;
    return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }
  function exportCSV() {
    if (!state.sessions.length) { status('backup', 'There aren\u2019t any sessions to put in a spreadsheet yet.'); return; }
    var rows = [['Date', 'Session', 'Minutes', 'Worked on', 'How it felt', 'Notes']];
    state.sessions.slice().sort(function (a, b) { return a.date < b.date ? -1 : a.date > b.date ? 1 : 0; }).forEach(function (s) {
      rows.push([s.date, TYPES[s.type], s.min, s.worked.concat(s.other ? [s.other] : []).join('; '), s.felt || '', s.notes]);
    });
    download('ast-practice-sessions-' + today() + '.csv', '\ufeff' + rows.map(function (r) { return r.map(csvCell).join(','); }).join('\r\n'), 'text/csv');
    status('backup', 'The spreadsheet of your sessions is in your downloads. To move your whole log to another phone, use Save a backup instead.');
  }
  function describe(d) {
    var parts = [plural(d.sessions.length, 'session', 'sessions')];
    var gm = Object.keys(d.goals).length;
    var em = Object.keys(d.elements.status).length;
    if (gm) parts.push(plural(gm, 'month of goals', 'months of goals'));
    if (em) parts.push(plural(em, 'marked element', 'marked elements'));
    if (d.elements.custom.length) parts.push(plural(d.elements.custom.length, 'element of your own', 'elements of your own'));
    if (d.events.length) parts.push(plural(d.events.length, 'test or competition', 'tests and competitions'));
    if (d.costs.length) parts.push(plural(d.costs.length, 'cost', 'costs'));
    return parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0];
  }
  function importBox(html) {
    var box = $('[data-pt-import-confirm]');
    $('[data-pt-erase-confirm]').hidden = true;
    box.innerHTML = html;
    box.hidden = !html;
    if (html) {
      var first = $('button', box);
      (first || box).focus();
    }
  }
  function importError(msg) {
    pendingImport = null;
    importBox('<p>' + esc(msg) + '</p><div class="ast-pt__actions"><button type="button" class="btn btn--secondary" data-pt-action="import-cancel">OK</button></div>');
  }
  function showImport(r, raw) {
    pendingImport = r;
    var when = raw && typeof raw.exported === 'string' && !isNaN(Date.parse(raw.exported)) ? ' from ' + fmtFull.format(new Date(raw.exported)) : '';
    var html = '<p>This backup' + esc(when) + ' has ' + esc(describe(r.data)) + '.' +
      (r.dropped ? ' ' + plural(r.dropped, 'entry in it couldn\u2019t be read and will be left out.', 'entries in it couldn\u2019t be read and will be left out.') : '') + '</p>';
    if (hasData(state)) {
      html += '<p>This device already has ' + esc(describe(state)) + '. You can add the backup to what\u2019s here, which skips anything that\u2019s already in your log, or replace everything here with the backup.</p>' +
        '<div class="ast-pt__actions ast-pt__actions--wrap"><button type="button" class="btn btn--primary" data-pt-action="import-merge">Add it to my log</button>' +
        '<button type="button" class="btn btn--secondary" data-pt-action="import-replace-ask">Replace my log</button>' +
        '<button type="button" class="btn btn--secondary" data-pt-action="import-cancel">Cancel</button></div>';
    } else {
      html += '<div class="ast-pt__actions ast-pt__actions--wrap"><button type="button" class="btn btn--primary" data-pt-action="import-replace">Restore this backup</button>' +
        '<button type="button" class="btn btn--secondary" data-pt-action="import-cancel">Cancel</button></div>';
    }
    importBox(html);
  }
  function merge(a, b) {
    var out = JSON.parse(JSON.stringify(a));
    ['sessions', 'events', 'costs'].forEach(function (k) {
      var ids = {};
      out[k].forEach(function (x) { ids[x.id] = 1; });
      b[k].forEach(function (x) { if (!ids[x.id]) out[k].push(x); });
    });
    Object.keys(b.goals).forEach(function (m) { if (!out.goals[m]) out.goals[m] = b.goals[m]; });
    var names = {};
    out.elements.custom.forEach(function (c) { names[c.name.toLowerCase()] = c.id; });
    b.elements.custom.forEach(function (c) {
      if (names[c.name.toLowerCase()]) {
        var mine = names[c.name.toLowerCase()];
        if (!out.elements.status[mine] && b.elements.status[c.id]) out.elements.status[mine] = b.elements.status[c.id];
        return;
      }
      out.elements.custom.push(c);
      names[c.name.toLowerCase()] = c.id;
      if (b.elements.status[c.id]) out.elements.status[c.id] = b.elements.status[c.id];
    });
    Object.keys(b.elements.status).forEach(function (k) {
      if (k.indexOf('c-') !== 0 && !out.elements.status[k]) out.elements.status[k] = b.elements.status[k];
    });
    if (b.meta.backup && (!out.meta.backup || b.meta.backup > out.meta.backup)) out.meta.backup = b.meta.backup;
    return out;
  }
  function applyImport(mode) {
    if (!pendingImport) return;
    var data = pendingImport.data;
    state = mode === 'merge' ? merge(state, data) : JSON.parse(JSON.stringify(data));
    pendingImport = null;
    var ok = writeStore();
    importBox('');
    resetAllForms();
    renderAll();
    status('backup', ok ? 'Your backup is restored, and this device now has ' + describe(state) + '.' : 'The backup is on the page, but the browser wouldn\u2019t save it.');
    $('#ast-pt-backup-title').setAttribute('tabindex', '-1');
    $('#ast-pt-backup-title').focus();
  }
  $('[data-pt-import]').addEventListener('change', function (e) {
    var input = e.target;
    var file = input.files && input.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { input.value = ''; importError('That file is too big to be a tracker backup. Choose the .json file you saved with Save a backup.'); return; }
    var reader = new FileReader();
    reader.onload = function () {
      input.value = '';
      var raw;
      try { raw = JSON.parse(String(reader.result).replace(/^\ufeff/, '')); } catch (err) {
        importError('That file couldn\u2019t be read as a backup. Choose the .json file you saved with Save a backup.');
        return;
      }
      var r = clean(raw);
      if (!r) { importError('That file isn\u2019t a practice tracker backup. Choose the .json file you saved with Save a backup.'); return; }
      if (r.error === 'newer') { importError('This backup was made by a newer version of the tracker. Reload the page and try again.'); return; }
      showImport(r, raw);
    };
    reader.onerror = function () { input.value = ''; importError('The browser couldn\u2019t open that file. Try choosing it again.'); };
    reader.readAsText(file);
  });

  /* ---------- Clicks ---------- */
  function shiftMonth(panel, delta) {
    if (panel === 'goals') {
      var g = new Date(gview.y, gview.m + delta, 1);
      gview = { y: g.getFullYear(), m: g.getMonth() };
      renderGoals();
      status('goals', '');
    } else {
      var d = new Date(view.y, view.m + delta, 1);
      view = { y: d.getFullYear(), m: d.getMonth() };
      renderSessions();
    }
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button') : null;
    if (!b || !root.contains(b)) return;
    var id = b.getAttribute('data-id');
    if (b.hasAttribute('data-pt-tab')) { selectTab(b.getAttribute('data-pt-tab')); return; }
    if (b.hasAttribute('data-pt-min')) {
      var m = field(sessionForm, 'min');
      m.value = b.getAttribute('data-pt-min');
      m.removeAttribute('aria-invalid');
      return;
    }
    if (b.hasAttribute('data-pt-month')) { shiftMonth(b.closest('[data-pt-panel]').getAttribute('data-pt-panel'), +b.getAttribute('data-pt-month')); return; }
    if (b.hasAttribute('data-pt-day')) {
      var k = b.getAttribute('data-pt-day');
      var first = $$('[data-pt-date]').filter(function (x) { return x.getAttribute('data-pt-date') === k; })[0];
      reveal(first);
      return;
    }
    if (b.hasAttribute('data-pt-goto')) {
      selectTab(b.getAttribute('data-pt-goto'));
      reveal($('[data-pt-log-title]'), field(sessionForm, 'date'));
      return;
    }
    if (b.hasAttribute('data-pt-edit')) { startEdit(b.getAttribute('data-pt-edit'), id); return; }
    if (b.hasAttribute('data-pt-del')) { askDelete(id); return; }
    if (b.hasAttribute('data-pt-del-yes')) { doDelete(b.getAttribute('data-pt-del-yes'), id); return; }
    if (b.hasAttribute('data-pt-del-no')) { cancelDelete(id); return; }
    if (b.hasAttribute('data-pt-cancel')) { cancelEdit(b.getAttribute('data-pt-cancel')); return; }
    switch (b.getAttribute('data-pt-action')) {
      case 'export-json': exportJSON(); break;
      case 'export-csv': exportCSV(); break;
      case 'import-merge': applyImport('merge'); break;
      case 'import-replace': applyImport('replace'); break;
      case 'import-replace-ask':
        importBox('<p>Replacing deletes the ' + esc(describe(state)) + ' on this device and puts the backup in their place. Save a backup of this device first if you might want any of it.</p>' +
          '<div class="ast-pt__actions ast-pt__actions--wrap"><button type="button" class="btn btn--secondary ast-pt__danger" data-pt-action="import-replace">Yes, replace my log</button>' +
          '<button type="button" class="btn btn--secondary" data-pt-action="import-cancel">Cancel</button></div>');
        break;
      case 'import-cancel':
        pendingImport = null;
        importBox('');
        $('[data-pt-import]').focus();
        break;
      case 'erase-ask':
        if (!hasData(state)) { status('backup', 'There\u2019s nothing saved on this device to erase.'); break; }
        importBox('');
        $('[data-pt-erase-confirm]').hidden = false;
        $('[data-pt-action="erase-no"]').focus();
        break;
      case 'erase-no':
        $('[data-pt-erase-confirm]').hidden = true;
        $('[data-pt-action="erase-ask"]').focus();
        break;
      case 'erase-yes':
        state = blank();
        var ok = writeStore();
        $('[data-pt-erase-confirm]').hidden = true;
        resetAllForms();
        renderAll();
        status('backup', ok ? 'Everything on this device has been erased.' : '');
        $('[data-pt-action="erase-ask"]').focus();
        break;
    }
  });

  /* ---------- Everything ---------- */
  function resetAllForms() {
    resetSessionForm();
    resetEventForm();
    resetCostForm();
  }
  function renderAll() {
    renderTotals();
    renderSessions();
    renderGoals();
    renderElements();
    renderWorked(currentWorked());
    renderEvents();
    renderCosts();
    renderBackupMeta();
    $('[data-pt-log-example]').hidden = state.sessions.length > 0;
  }

  function onlineState() { $('[data-pt-offline]').hidden = navigator.onLine !== false; }
  window.addEventListener('online', onlineState);
  window.addEventListener('offline', onlineState);
  /* Another tab on the same browser saved: pick up its copy */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    state = readStore();
    renderAll();
    showStorage();
  });

  probeStore();
  showStorage();
  onlineState();
  resetAllForms();
  renderAll();
  var hash = (location.hash || '').replace('#', '');
  if ($('[data-pt-panel="' + hash + '"]')) selectTab(hash, false, true);
  else selectTab('log', false, true);
  root.classList.add('is-ready');
})();
